import { LcmModel } from "../../domain/LcmModel";

export const defaultValues: Partial<LcmModel> = {
 
  createdUpn: "",
  createdByDisplayName: "",
  modifiedbyUpn: "",
  caseTitle: "",
  status: 696,
  summary: "",
  directorate: [],
  team: "",
  requestedBy: null,
  matterType: null,
  category: null,
  subCategory: null,
  dueDate: "",
  lineManagerUpn: "",
  lineManagerDisplayName: "",
  counselTelephone: "",
  counselEmail: "",
  counselTags: "",
  counselSummaryAdvice: "",
  counselReceivedFrom: "",
  counselKeywords: "",
  sensitive: false,
  assignedCreatedDate: "",
  assignedTo: [],
};
